import React, { useCallback, useEffect, useState, useRef } from 'react';

import styles from './Banner.module.less';
import Button from '../Button';
import GameLink from '../GameLink';
import Carousel from '../hocs/Carousel';

const Banner = ({ $el, data, index, count, turnPage, tag: source }) => {
  const [backgroundPX, setBackgroundPX] = useState(1110);

  // 窗口变化的过程中，重新计算应该模糊的位置。
  const handleResize = useCallback(() => {
    let offsetWidth = $el.current.offsetWidth;
    let infoWidth = 250;
    let maxWidth = 1660;
    let backgroundPositionX = (offsetWidth + maxWidth) / 2 - infoWidth;
    setBackgroundPX(backgroundPositionX);
  }, [$el]);

  // 监听浏览器大小变化自动适应
  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <div className={styles.Banner} ref={$el}>
      {data.map((o, bIndex) => {
        let id = o.pageCardContentId || '';
        let type = 'zt';
        let footer = (
          <div>
            <button className={styles.ViewButton}>查看</button>
          </div>
        );
        if (o.targetType === '1' && o.appInfo) {
          id = o.appInfo.softID || '';
          if (o.appInfo.androidType === '1') {
            id = o.appInfo.packageName;
          }
          type = 'soft';
          footer = (
            <div>
              <Button soft={o.appInfo} className="action banner" size="big" logInfo={{ source }} />
              <span>{o.appInfo.downloadCount || '1万次'}安装</span>
            </div>
          );
        }
        if (o.targetType === '5') {
          type = 'sell';
          footer = (
            <div>
              <button className={styles.SaleButton}>购买</button>
            </div>
          );
        }

        return (
          <div className={'banner_item'} key={bIndex}>
            <GameLink
              info={o}
              source={source}
              logInfo={{
                category: 'C',
                action: 'Game_Non_Button',
                params: {
                  id,
                  type,
                  source,
                },
                bizInfo: o.bizInfo,
              }}
            >
              <img className={'banner_item_bg'} src={o.contentImgBig || o.contentImg} />
              {/* <b style={{ backgroundImage: `url("${o.contentImg}")` }}></b> */}
              <div
                className="info_bg"
                style={{
                  backgroundImage: `url(${o.contentImgBig || o.contentImg})`,
                  backgroundPosition: `-${backgroundPX}px 0px`,
                }}
              ></div>
              <div className="info">
                <h1 title={o.contentTitle}>{o.contentTitle}</h1>
                <p>{o.contentDesc}</p>
                {footer}
              </div>
            </GameLink>
          </div>
        );
      })}
      {count > 1 && (
        <ol>
          {Array.from({ length: count }).map((o, ii) => {
            return (
              <li
                key={ii}
                className={ii === index ? 'active' : ''}
                onMouseEnter={() => turnPage(ii)}
              ></li>
            );
          })}
        </ol>
      )}
    </div>
  );
};

export default Carousel(Banner);
